const SmsAlert = () => {
  return (
    <>
        <div className="AlertInnerBox AlertInnerBox2 YellowAlertInnerBox alert alert-dismissible fade show">
        <div className="Icon_box">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a>
            <span className="material-symbols-outlined">warning</span>
          </a>
        </div>
        <div className="alert_text">
          <h6>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>QR code is not available. Kindly access the service and submit a new questionnaire.</a>
          </h6>
        </div>
      </div>
        </>);

};

export default SmsAlert;